// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1TOuZ","alert":"SettungsInbox_alert__1j8Gj"};